import { useTranslation } from 'react-i18next';

export default function HeroWithAbstract() {
  const { t } = useTranslation();

  const paragraphs = [t('abstract_p1'), t('abstract_p2'), t('abstract_p3'), t('abstract_p4'), t('abstract_p5')];

  return (
    <section className="bg-background-50 relative">
      {/* Language toggle — top right corner */}
      <div className="absolute top-6 right-4 md:right-8 lg:right-12 z-10">
        <LangToggle />
      </div>

      <div className="w-full px-4 md:px-8 lg:px-12 pt-16 pb-10 md:pt-20 md:pb-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">
            {/* Left: Book cover + download */}
            <div className="flex flex-col items-center lg:items-start">
              {/* Book cover image */}
              <div className="relative w-full max-w-sm mx-auto lg:mx-0">
                <div className="rounded-xl overflow-hidden shadow-xl shadow-primary-900/20 bg-[#0a1628]">
                  <img
                    src="/images/book-cover.webp"
                    alt="China Blue Book on Sarcopenia First Edition Cover"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>

              <div className="relative mt-6 w-full max-w-sm mx-auto lg:mx-0">
                <div className="flex flex-col gap-3">
                  <a
                    href={`${__BASE_PATH__}bluebook2026.pdf`}
                    download="bluebook2026.pdf"
                    className="w-full inline-flex items-center justify-center gap-3 bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600 px-8 py-4 rounded-lg text-base font-semibold whitespace-nowrap transition-colors cursor-pointer"
                  >
                    <i className="ri-download-line text-xl"></i>
                    {t('hero_download_btn')}
                  </a>
                </div>
              </div>
            </div>

            {/* Right: Abstract */}
            <div className="flex flex-col">
              {/* Abstract paragraphs */}
              <div className="space-y-4">
                {paragraphs.map((text, index) => (
                  <p
                    key={index}
                    className="text-foreground-700 text-sm md:text-base leading-relaxed text-justify"
                  >
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function LangToggle() {
  const { i18n } = useTranslation();

  const toggleLang = () => {
    const next = i18n.language === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={toggleLang}
      className="text-sm font-medium px-3 py-1.5 rounded-md border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors whitespace-nowrap bg-background-50"
    >
      {i18n.language === 'zh' ? 'EN' : '中文'}
    </button>
  );
}